( function() {

	var atTop = new Event( 'atTop' );
	var belowTop = new Event( 'belowTop' );

	function svgBegin( id ) {
		var el = document.getElementById( id );
		if ( el && el.beginElement ) el.beginElement();
	}

	function testScrollTop() {

		if ( document.body.classList.contains( 'template-product' ) ) {
			document.body.classList.add( 'below-top' );
			document.body.classList.remove( 'at-top' );
			return;
		}

		var scrollY = ( window.pageYOffset || document.documentElement.scrollTop );
		if ( scrollY > 0 ) {
			if ( document.body.classList.contains( 'at-top' )
			&& ! document.body.classList.contains( 'showing-nav' )
			&& document.body.classList.contains( 'curve-opened' ) ) {
				document.body.classList.remove( 'curve-opened' );
				svgBegin( 'close-curve' );
				svgBegin( 'close-mask' );
			}
			document.body.classList.remove( 'at-top' );
			document.body.classList.add( 'below-top' );
		} else {
			if ( document.body.classList.contains( 'below-top' )
			&& ! document.body.classList.contains( 'showing-nav' )
			&& ! document.body.classList.contains( 'mobile-nav-open' )
			&& ! document.body.classList.contains( 'curve-opened' )
			&& ! document.body.classList.contains( 'collapsed-header' ) ) {
				document.body.classList.add( 'curve-opened' );
				svgBegin( 'open-curve' );
				svgBegin( 'open-mask' );
			}
			document.body.classList.add( 'at-top' );
			document.body.classList.remove( 'below-top' );
		}


	}

	function maybeCloseCurve() {

		if ( window.innerHeight < 750 && document.body.classList.contains( 'curve-opened' ) && ! document.body.classList.contains( 'at-top' ) ) {
			document.body.classList.remove( 'curve-opened' );
			svgBegin( 'close-curve' );
			svgBegin( 'close-mask' );
		}

		if ( window.innerHeight >= 751 ) {
			document.body.classList.remove( 'mobile-nav-open' );
		}

	}

	function maybeShowNav( e ) {
		var location = e.clientY / window.innerHeight;

		if ( document.body.classList.contains( 'always-collapsed' ) ) {
			if ( document.body.classList.contains( 'showing-nav' ) ) {
				document.body.classList.remove( 'showing-nav' );
			}
			if ( document.body.classList.contains( 'curve-opened' ) ) {
				document.body.classList.remove( 'curve-opened' );
				svgBegin( 'close-curve' );
				svgBegin( 'close-mask' );
			}
			return;
		}

		if ( window.innerHeight < 750 ) {
			maybeCloseCurve();
			document.body.classList.remove( 'showing-nav' );
			return;
		}

		if ( e.clientY < 50 && ! document.body.classList.contains( 'showing-nav' ) ) {
			document.body.classList.add( 'showing-nav' );
			if ( ! document.body.classList.contains( 'at-top' ) || document.body.classList.contains( 'collapsed-header' ) ) {
				document.body.classList.add( 'curve-opened' );
				svgBegin( 'open-curve' );
				svgBegin( 'open-mask' );
			}
		}

		if ( location >= 0.2 && document.body.classList.contains( 'showing-nav' ) ) {
			document.body.classList.remove( 'showing-nav' );
			if ( ! document.body.classList.contains( 'at-top' ) || document.body.classList.contains( 'collapsed-header' ) ) {
				document.body.classList.remove( 'curve-opened' );
				svgBegin( 'close-curve' );
				svgBegin( 'close-mask' );
			}
		}
	}

	function installHeadernav() {

		if ( document.readyState !== 'complete' || document.body.classList.contains( 'header-installed' ) ) {
			return;
		}

		document.body.addEventListener( 'mousemove', maybeShowNav );
		window.addEventListener( 'resize', maybeCloseCurve );

		window.addEventListener( 'scroll', testScrollTop );
		testScrollTop();

		var scrollY = ( window.pageYOffset || document.documentElement.scrollTop );
		if ( scrollY > 0 && document.body.classList.contains( 'curve-opened' ) ) {
			document.body.classList.remove( 'curve-opened' );
			svgBegin( 'close-curve' );
			svgBegin( 'close-mask' );
		}

		if ( document.body.classList.contains( 'collapsed-header' ) && !document.body.classList.contains( 'template-product' ) ) {
			svgBegin( 'close-curve' );
		}

		// Product pages: drop collapsed-header — below-top (already set by testScrollTop) is the standard scrolled state
		if ( document.body.classList.contains( 'template-product' ) ) {
			document.body.classList.remove( 'collapsed-header' );
		}

		document.body.classList.add( 'header-installed' );

		var navBtn = document.querySelector( 'button[aria-controls="site-navigation"]' );
		if ( navBtn ) navBtn.addEventListener( 'click', toggleNavigation );

	}

	function toggleNavigation( e ) {

		document.body.classList.toggle( 'mobile-nav-open' );

		if ( document.body.classList.contains( 'mobile-nav-open' ) ) {
			e.currentTarget.setAttribute( 'aria-expanded', 'true' );

			if ( document.body.classList.contains( 'curve-opened' ) ) {
				document.body.classList.remove( 'curve-opened' );
				svgBegin( 'close-curve' );
				svgBegin( 'close-mask' );
			}

		} else {
			e.currentTarget.setAttribute( 'aria-expanded', 'false' );

			if ( document.body.classList.contains( 'at-top' ) && ! document.body.classList.contains( 'collapsed-header' ) ) {
				document.body.classList.add( 'curve-opened' );
				svgBegin( 'open-curve' );
				svgBegin( 'open-mask' );
			}
		}

	}


	if ( document.readyState === 'complete' ) {

		installHeadernav();

	} else {

		document.addEventListener( 'readystatechange', installHeadernav );

	}


} )();
